<template>
  <div class="CasamentosEHabilitacoes">
    <div class="CasamentosEHabilitacoes_header p-4">
      <SearchCasamento @search="getTarefas"
                       @showError="displayError" />
    </div>
    <div v-if="registros.length"
         class="CasamentosEHabilitacoes_body">
      <div class="col-12 d-inline-flex justify-content-between align-items-center m-0 p-0 mb-2">
        <div class="d-inline-flex">
          <b-form-checkbox
            id="select_all_habilitacoes"
            v-model="select_all"
            name="select_all_habilitacoes"
            :value="true"
            class="CasamentosEHabilitacoes_tipos text-capitalize"
            :disabled="!registros.find(registro => registro.status != 'CUMPRIDA')"
            @change="selectAll" />
          <label for="select_all_habilitacoes"
                 class="CasamentosEHabilitacoes_label m-0 p-0">
            Selecionar todas as habilitações
          </label>
        </div>

        <div class="d-inline-flex">
          <div class="d-inline-flex align-items-center mr-4">
            <label for="mostrar"
                   class="CasamentosEHabilitacoes_label m-0 p-0 mr-1">
              Mostrar:
            </label>
            <select id="mostrar"
                    v-model="perPage"
                    class="form-control form-control-sm"
                    @change="reload()">
              <option v-for="(value, index) in [10,20,30,40,50]"
                      :key="index"
                      :value="value">
                {{ value }}
              </option>
            </select>
          </div>
          <div class="d-inline-flex align-items-center">
            <label for="ordenar"
                   class="CasamentosEHabilitacoes_label m-0 p-0 mr-1 text-nowrap">
              Ordernar por:
            </label>
            <select id="ordenar"
                    v-model="orderBy"
                    class="form-control form-control-sm"
                    @change="reload()">
              <option v-for="(order, index) in selects.order"
                      :key="index"
                      :value="order.value">
                {{ order.label }}
              </option>
            </select>
          </div>
        </div>
      </div>
      <BoxCasamento v-for="(registro, index) in registros"
                    :key="index"
                    :prop-registro="registro"
                    :prop-selected="!!selecteds.find(registro_id => registro_id === registro.registro_id)"
                    class="mb-2"
                    :prop-index="index"
                    @addSelected="addSelected"
                    @removeSelected="removeSelected"
                    @reload="reload(page)" />
    </div>
    <div v-if="registros.length"
         class="CasamentosEHabilitacoes_action col-12 d-inline-flex justify-content-end align-items-center p-0 m-0 p-4 mt-2">
      <button class="btn btn-sm CasamentosEHabilitacoes_cumprir px-4"
              :disabled="!selecteds.length"
              @click="confirmCumprimento">
        <IconSvg icon="done"
                 class="icon--sm icon_done" />
        Cumprir todas as selecionadas
      </button>
    </div>
    <div v-if="registros.length"
         class="CasamentosEHabilitacoes_footer col-12 justify-content-center align-items-center p-0 m-0 mt-2">
      <Pagination
        :per-page="perPage"
        :page="page"
        :last-page="lastPage"
        @onPreviousPage="reload(page - 1)"
        @onNextPage="reload (page + 1)" />
    </div>

    <div>
      <b-modal v-if="errorsProclamas.status"
               id="modalMotivoAlteracao"
               ref="modalMotivoAlteracao"
               centered
               size="lg"
               :visible="true"
               title="Status da carga:"
               @hide="hideErrors()">
        {{ errorsProclamas.text }}
        <hr>
        <h6 class="mb-1">
          Cargas com erro:
        </h6>

        <collapse-default v-for="(task, index) in errorsProclamas.tasks"
                          :id="`${ _uid }_task_${ index }`"
                          :key="`${ _uid }_task_${ index }`"
                          icon-position="left"
                          :collapse-visible="index == 0"
                          class="GerenciadorResultadosItem">
          <template v-slot:header>
            <span>
              {{ task.habilitacaoData.registro.pessoas[0].nome_antigo || task.habilitacaoData.registro.pessoas[0].nome }}
              e
              {{ task.habilitacaoData.registro.pessoas[1].nome_antigo || task.habilitacaoData.registro.pessoas[1].nome }}
            </span>
            <button class="mr-1 btn btn-danger btn-sm float-right GerenciadorResultadosItem--btnAjustar"
                    @click="openRegister(task.habilitacaoData)">
              Ajustar
            </button>
          </template>

          <template v-slot:content>
            <div class="p-2">
              <label class="label">
                Erros do registro:
              </label>
              <ul v-if="Array.isArray(task.message)">
                <li v-for="(error, indexes) in task.message"
                    :key="`${ _uid }_erro_task_${ indexes }`">
                  {{ error }}
                </li>
              </ul>
              <ul v-else>
                <li v-if="!!task.message">
                  {{ task.message }}
                </li>
                <li v-if="typeof task.message == 'string'">
                  {{ task.message }}
                </li>
              </ul>
            </div>
          </template>
        </collapse-default>
      </b-modal>
    </div>
    <EProclamas ref="EProclamas"
                :prop-registros="selecteds"
                :prop-lote="true"
                :prop-resultados="registros"
                @showErrors="getErrorsProclamas"
                @reload="reload()" />
  </div>
</template>
<script>
  //Components
  import BoxCasamento from "./BoxCasamento"
  import Pagination from "@/components/SofiaRei/Pagination"
  import SearchCasamento from "./SearchCasamento"
  import CollapseDefault from "@/components/SofiaRei/Resumo/Collapses/CollapseDefault"
  import EProclamas from "@/components/SofiaRei/EProclamas/eProclamas"

  //Services
  import GerenciadorService from "@/services/GerenciadorService"

  //Constants
  import errorsList from '@/constants/errorsCasamento'

  //Outros
  import Swal from 'sweetalert2'
  import {mapGetters} from "vuex"

  /* constants */
  import { GERENCIADOR_TAREFAS_ENVIAR, ADMIN } from "@/constants/permissions"


  export default {
    name: "CasamentosEHabilitacoes",
    components: {
      BoxCasamento,
      Pagination,
      SearchCasamento,
      CollapseDefault,
      EProclamas
    },
    data () {
      return {
        selects: {
          order: [
            { label: 'Data Inclusão', value: 'data_inclusao' },
            { label: 'Data Registro', value: 'data_registro' },
            { label: 'Data Cumprimento', value: 'data_cumprimento' },
            { label: 'Data Habilitação', value: 'data_habilitacao' },
            { label: 'Data Entrada', value: 'data_entrada' },
            { label: 'Data Publicação', value: 'data_publicacao' },
            { label: 'Data Casamento', value: 'data_casamento'}
          ]
        },
        registros: [],
        selecteds: [],
        select_all: false,
        page: 1,
        lastPage: 1,
        perPage: 10,
        search: {},
        orderBy: 'data_inclusao',
        errorsProclamas: {},
        success: [],
        showModal: false,
        GERENCIADOR_TAREFAS_ENVIAR,
        ADMIN
      }
    },
    computed: {
      ...mapGetters({
        user: 'auth/getUser'
      })
    },
    methods: {
      async getTarefas (params) {
        try {
          loader({active: true, text: ""})

          //removendo espacos da matricula
          const matricula = params.matricula ? params.matricula.replace(/ /g, '') : null

          params.searchHabilitacaoCasamento = true

          this.registros = []
          this.selecteds = []
          this.select_all = false
          this.search = { ...params, matricula }

          const res = await GerenciadorService.getTarefas(this.search)

          if (res.data.length) {
            this.registros = res.data
            this.page = res.page
            this.lastPage = res.lastPage
            this.perPage = res.perPage
          }
          else this.displayError("", "Nenhum registro encontrado!")
        } catch (error) {
          this.displayError("Erro!", error)
        } finally {
          loader({active: false, text: ""})
          this.scrollList()
        }
      },
      async reload (page = 1) {
        try {
          loader({active: true, text: ""})

          this.select_all = false

          const params = {
            ...this.search,
            page,
            perPage: this.perPage,
            orderBy: this.orderBy
          }

          const res = await GerenciadorService.getTarefas(params)

          if (res.data.length) {
            this.registros = res.data
            this.page = res.page
            this.lastPage = res.lastPage

            this.selecteds = this.selecteds.filter(selected =>
              this.registros.find(registro => registro.registro_id === selected)
            )
          } else if (page > 1) {
            this.reload(this.page - 1)
          }  else  {
            if (page === 1) {
              this.registros = []
              this.page = 1
              this.lastPage = 1
            }

            this.selecteds = []

            this.displayError("", "Nenhum registro encontrado!")
          }
        } catch (error) {
          this.displayError("Erro!", error)
        } finally {
          loader({active: false, text: ""})
          this.scrollList()
        }
      },
      async confirmCumprimento () {
        if (!this.selecteds.length) {
          return this.displayError("", "Nenhum registro selecionado.")
        }

        const response  = await this.displayQuestion("","", `Confirmar o cumprimento de <b>${this.selecteds.length}</b> tarefas?`)

        /**
         * Verificamos a permissão no método pois a publicação também é chamada
         * fora do gerenciador de tarefas
         *
         * Se o usuário for oficial ou suporte não validamos
         */
        const { groups, flag_oficial } = this.user

        let login = ''

        if (this.user) {
          login = this.user.login.split('_')[0]
        }

        if (groups && groups.length && !flag_oficial) {
          let access = false
          const permissions = [this.GERENCIADOR_TAREFAS_ENVIAR, this.ADMIN]

          groups.forEach(group => {
            const permission = !!group.permissions.find(permission => !!permissions.includes(permission.codename))

            if (permission && group.ativo) access = true
          })

          if (!access) {
            return displayMessage('error', 'Acesso negado!', 'Você não tem permissão para acessar essa função.')
          }
        } else if (login !== 'suporte' && !flag_oficial) {
          return displayMessage('error', 'Acesso negado!', 'Você não tem permissão para acessar essa função.')
        }

        if (response.value) {
          // Usamos a ref pra chamar uma função dentro de outro componente
          this.$refs.EProclamas.handlePublicacao()
        }
      },
      displaySuccess (title, text, html) {
        objSwal.success.title = title
        objSwal.success.text = text
        objSwal.success.html = html

        return Swal.fire(objSwal.success).then(() => {
          objSwal.success.title = ''
          objSwal.success.text = ''
          objSwal.success.html = ''
        })
      },
      displayError (title, text, html) {
        objSwal.error.title = title
        objSwal.error.text = text
        objSwal.error.html = html

        return Swal.fire(objSwal.error).then(() => {
          objSwal.error.title = ''
          objSwal.error.text = ''
          objSwal.error.html = ''
        })
      },
      displayQuestion (title, text, html) {
        objSwal.question.title = title
        objSwal.question.text = text
        objSwal.question.html = html
        objSwal.question.cancelButtonText = 'Não'
        objSwal.question.confirmButtonText = 'Sim'
        objSwal.question.input = null
        objSwal.question.inputValue = null
        objSwal.question.inputClass = null
        objSwal.question.inputOptions = null

        return Swal.fire(objSwal.question).then(res => {
          objSwal.question.title = ''
          objSwal.question.text = ''
          objSwal.question.html = ''

          return res
        })
      },
      selectAll () {
        setTimeout (() => {
          if (this.select_all) {
            this.selecteds = this.registros.filter(registro => registro.status != "CUMPRIDA" && registro.acao === 'PUBLICAR_PROCLAMAS')
              .map(registro => registro.registro_id)
          } else {
            this.selecteds = []
          }
        }, 100)
      },
      addSelected (registro_id) {
        this.selecteds.push(registro_id)
      },
      removeSelected (registro_id) {
        const index = this.selecteds.findIndex(item => item === registro_id)

        if (index >= 0) {
          this.selecteds.splice(index, 1)
        }
      },
      scrollList () {
        setTimeout(() => {
          const listagem = document.querySelectorAll('#status')

          if (listagem.length) {
            listagem[0].scrollIntoView({ behavior: 'smooth', block: 'start', inline: "start" })
          }
        }, 100)
      },
      getErrorsProclamas (error) {
        /**
         * Percorremos as mensagens de erro para alterar as palavras erradas
         */
        error.tasks.forEach(task => {
          if (Array.isArray(task.message)) {
            task.message = task.message.map((text) => {
              errorsList.forEach(err => {
                text = text.replace(err.name, err.value)
              })

              return text
            })
          }
        })

        this.errorsProclamas = error
      },
      hideErrors () {
        this.errorsProclamas = {}
      },
      openRegister (habilitacao) {
        this.$router.push({name: 'editar_habilitacao_casamento', params: { id: habilitacao.habilitacao_casamento_id }})
      },
    }
  }
</script>
<style lang="scss">
  .CasamentosEHabilitacoes {
    &_action {
      border: solid 1px #707070;
      background: #ffffff;
      position: sticky;
      bottom: 10px;
      z-index: 2;
    }

    &_label {
      font-size: 16px;
      font-weight: 500;
      color: #373a3c;
    }

    &_tipos {
      font-size: 16px;
      font-weight: normal;
      color: #000000;

      &_icon {
        width: 18px;
        height: 18px;
      }
    }

    &_cumprir {
      border: solid 1px #205e3b;
      background: #205e3b;
      font-size: 16px;
      font-weight: normal;
      text-align: center;
      color: #ffffff;
      fill: #FFFFFF;
    }

    &_cumprir:hover {
      color: #FFFFFF;
    }
  }
</style>
